import { secureServer } from './AppSettings';

export const settings = {
    phone1: '+1 (877) 403-8082',
    phone2: '+1 (905) 812-8434',
    fax: '+1 (647) 795-2904',
    hours: '9am to 6pm EST',
    email: 'sales @ lsoft.net',
    supportEmail: 'support @ lsoft.net',
    address: ['7177 Danton Promenade', 'Mississauga, ON', 'L5N 5P3', 'Canada'],
    mapUrl: 'https://maps.google.com/maps?q=7177%20Danton%20Prom&t=&z=13&ie=UTF8&iwloc=&output=embed',
    website: {
        name: 'www.lsoft.net',
        url: 'https://www.lsoft.net',
    },
    domainName: 'http://lsoft.net',
    secureWebOrderUrl: `${secureServer}/Order.aspx`,
    socials: {
        facebook: 'http://www.facebook.com/pages/LSoft-Technologies/169521936414944',
        twitter: 'https://twitter.com/#!/lsoft_net',
        youtube: 'https://www.youtube.com/user/LsoftTechnologies',
    },
    hstNumber: '87239 4424 RT0001',
    year: '2026',
};
